import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsActive,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const ActiveStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(
    (page = 1, size = limit) => {
      fetchStatuses(
        "ACTIVE",
        "INSTALLING",
        query,
        setLeads,
        setIsLoading,
        setTotalCount,
        page,
        size
      ).then(() => {
        setCurrentPage(page);
        setLimit(size);
      });
    },
    [query, limit]
  );

  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  return (
    <div>
      <Table
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsActive}
        dataSource={getOrderStatusDataSource(leads, loadData)}
        pagination={false}
        scroll={{ y: 500 }}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
              status={record.data?.status}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ActiveStatus;